import { render } from "./journalManage.vue?vue&type=template&id=3e32640e&scoped=true"
import script from "./journalManage.vue?vue&type=script&lang=js"
export * from "./journalManage.vue?vue&type=script&lang=js"

import "./journalManage.vue?vue&type=style&index=0&id=3e32640e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e32640e"]])

export default __exports__